import { createAction } from '@reduxjs/toolkit';

import { Bonus } from '../types';

export const bonusInitRequest = createAction('bonus/init/request');
export const bonusInitSuccess = createAction<{ bonus: Bonus }>('bonus/init/success');
export const bonusInitFailure = createAction<string>('bonus/init/failure');

export const bonusStop = createAction('bonus/stop');

export const collectBonusRequest = createAction('bonus/collect/request');
export const collectBonusSuccess = createAction<{ chips: number }>('bonus/collect/success');
export const collectBonusFailure = createAction<string>('bonus/collect/failure');

export const hideCollectBonusAnimation = createAction('bonus/collect/animationHide');
export const collectedBonusEvent = createAction('bonus/socket/collectedBonus');
